module.exports = __webpack_public_path__ + "media/images/admin/icons/trello-2045bba67077fd78bb54ad95d6238f5d.svg";